module.exports = __webpack_public_path__ + "img/point-1.c460f697.png";